export class StaffMemberClass {
    userId : string;
    schoolId : number;
    educationalProgramId  : number;
    classesIds   : number[] = [];
    academicYearId : number;
    userTypeId  : number; 


}